// 我的档案相关
const EntranceTask = () => import('../pages/entranceTask/index.vue');

export default [
  {
    path: '/entranceTask',
    name: 'entranceTask',
    component: EntranceTask,
    meta: {
      title: '入学任务',
    },
  },
];
